
import Vue from 'vue';
import TokensSVG from '@/assets/TokensSVG.vue';
import { currencyTokens, getRunnitNodeDefCostRange, hundredthsToTokens } from '@run-diffusion/shared';
import { v4 as uuidv4 } from 'uuid';
import type { KitToolLabel as NodeDefLabel } from '@run-diffusion/shared';

export function createTokenCostLabel (costPerResult?: number | null): NodeDefLabel | null {
	if (!costPerResult || costPerResult <= 0) {
		return null;
	}

	return {
		id: uuidv4(),
		icon: 'custom-tokens-icon',
		// The chip computes the actual display label internally (single value or min-max range).
		// We keep this field required by NodeDefLabel.
		label: '',
		type: 'DEFAULT',
	};
}

export default Vue.extend({
	name: 'OfferingCardTokenChip',
	components: {
		TokensSVG,
	},
	props: {
		iconColor: {
			type: String,
			required: true,
		},
		costPerResult: {
			type: Number,
			default: 0,
		},
		costPerResultLogics: {
			type: Array,
			default: null,
		},
		fields: {
			type: Array,
			default: null,
		},
	},
	computed: {
		displayLabel (): string {
			const { minCostPerResult, maxCostPerResult } = getRunnitNodeDefCostRange(
				this.costPerResult,
				this.costPerResultLogics,
				this.fields,
			);

			if (minCostPerResult > 0 && maxCostPerResult > 0 && minCostPerResult !== maxCostPerResult) {
				const minVal = hundredthsToTokens(minCostPerResult);
				const maxVal = hundredthsToTokens(maxCostPerResult);
				return `${currencyTokens(minVal, true)}-${currencyTokens(maxVal, true)}`;
			}

			return currencyTokens(hundredthsToTokens(this.costPerResult));
		},
	},
});
